/**
 * 所有接口变量都以 api开头，例如：apiGetUserInfo
 */
 import { apiDelete, apiPost, apiPut } from 'utils'
 import { IAddEditAccountRequest, IAccountItem, IAccountListQuery} from 'model'
 import { IdList, PaginationResponse, XhhyResponse } from 'Xhhy-common/common'
  
  /**
   * 获取账户列表
   * @param params
   */
  export const apiAccountList = async (params: IAccountListQuery) => {
   return await apiPost<IAccountListQuery, PaginationResponse<IAccountItem>>(`/apppocapi/account/list`, params)
  }
 
  /**
   * 新建账户
   * @param params
   */
   export const apiAddAccount = async (params: IAddEditAccountRequest) => {
     return await apiPost<IAddEditAccountRequest, XhhyResponse>(`/apppocapi/account/save`, params)
   }

   /**
   *  修改账户
   * @param params
   */
    export const apiEditAccount = async (params: IAddEditAccountRequest) => {
      return await apiPost<IAddEditAccountRequest, XhhyResponse>(`/apppocapi/account/update`, params)
    }
 
   /**
   * 删除账户
   * @param params
   */
    export const apiDeleteAccount = async (params: IdList) => {
     return await apiPost<IdList, XhhyResponse>(`/apppocapi/account/delete`, params)
   }
 
  